import type {IFormDocumentUploadFile} from '../FormFileDropzone';

export const safeFileArrayParse = (value: any) => {
  try {
    const obj = !value
      ? []
      : typeof value === 'string'
      ? JSON.parse(value)
      : value;
    const uploadedFiles: IFormDocumentUploadFile[] = value
      ? Array.isArray(obj)
        ? obj
        : [obj]
      : [];

    return uploadedFiles;
  } catch {
    return [];
  }
};
